<h1 mat-dialog-title>Send Mail</h1>
<div mat-dialog-content>
  <div><span class="secondaryInfo">Enter Recipient Names</span></div>
  <input type="text" class="form-control" required placeholder="Enter Recipient Names(csv)" [(ngModel)]="recipientNames"
    #recipients="ngModel">
  <div *ngIf="recipients.invalid && (recipients.dirty || recipients.touched)" class="alert alert-danger">

    <div *ngIf="recipients.errors.required">
      RecipientNames are required.
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button type="button" class="btn btn-custom_primary ml-2 mr-2" mat-dialog-close (click)="cancel()">Cancel</button>
  <button type="button" class="btn btn-custom_primary ml-2 mr-2 deleteButton" (click)="sendMail()">Delete</button>
</div>